import { useEffect, useRef } from 'react';
import { reportMisActivity } from './misAudit';

export function useMisPageAudit(module) {
  const sent = useRef(false);
  useEffect(() => {
    if (!sent.current) { sent.current = true; reportMisActivity('PAGE_VIEW', module); }
  }, [module]);
}
// Debounce search typing; skip initial defaults and never collect arbitrary form inputs.
export function useMisFilterAudit(module, details) {
  const value = JSON.stringify(details);
  const previous = useRef(value);
  useEffect(() => {
    if (previous.current === value) return;
    const timer = setTimeout(() => {
      previous.current = value;
      reportMisActivity('FILTER_CHANGED', module, JSON.parse(value));
    }, 600);
    return () => clearTimeout(timer);
  }, [module, value]);
}
